module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "default_logo.f363ad9a.png";